import styled from 'styled-components'
import { FullPageGrid, constants } from '@epidemicsound/design-system'
import { useEnvironment } from 'hooks/hooks'
import { PortalNavigation as PortalNavigation } from './portal/Navigation'
import { InternalNavigation } from './internal/Navigation'
import { FC } from 'react'
import { Apps } from '../../utils'

export const LeftContent = styled.div`
    margin-top: 0.7rem;

    a:hover {
        text-decoration: none;
    }
`

export const StyledNav = styled.nav`
    position: fixed;
    width: 100%;
    min-height: 50px;
    top: 0;
    background-color: ${constants.COLORS.BLACK};
    z-index: 1000;
`

export const RightContent = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1.5rem;
`

export const StyledCol = styled(FullPageGrid.Col)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.5rem;

    span {
        font-size: 1rem;
    }
`

interface NavigationProps {
    isAuthenticated: boolean
    app: Apps
}

export const Navigation: FC<NavigationProps> = ({ isAuthenticated, app }) => {
    const { environment } = useEnvironment()

    if (app === 'DevPortal') {
        return <PortalNavigation isAuthenticated={isAuthenticated} />
    } else {
        return (
            <InternalNavigation
                environment={environment}
                isAuthenticated={isAuthenticated}
            />
        )
    }
}
